import { defineModule } from '@berky/module-contract'
export default defineModule({
  id: 'lieferantenvertraege',
  title: 'Lieferantenverträge',
  description:
    'Versicherungen, Mobilfunk, Leasing, Lizenzen und weitere laufende Verpflichtungen verwalten.',
  icon: 'FileText',
  order: 140,
  apiBasePath: '/api/lieferantenvertraege',
  roles: ['lieferantenvertraege.nutzer', 'lieferantenvertraege.admin'],
  routes: () => import('./src/routes'),
})
